/** Chat titles (chat-ui-spec §3.2 and §3.7). */

export const PROVISIONAL_TITLE_LENGTH = 38;

/** The title a chat gets on its first send: the question, cut to 38 characters plus "…". */
export function provisionalTitle(message: string): string {
  if (message.length <= PROVISIONAL_TITLE_LENGTH) return message;
  return `${message.slice(0, PROVISIONAL_TITLE_LENGTH).trimEnd()}…`;
}

/** What a sidebar row shows. */
export const chatRowTitle = (title: string | null | undefined): string => title || 'New chat';

/** A rename, trimmed; null (no change) when nothing is left. */
export function renamedTitle(value: string): string | null {
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}
